import React, { FC } from 'react';

import { Box, useTablet, BoxProps, useMobile } from 'Modules/ui3';


export type ContentBoxProps = BoxProps & {
    backgroundImage?: string;
    withBorder?: boolean;
}
export const ContentBox: FC<ContentBoxProps> = ({
    children, backgroundImage, withBorder, sx, ...props
}) => {
    const isMobile = useMobile();
    const isTablet = useTablet();
    return (
        <Box
            bgcolor='grayscale.shade0'
            borderRadius={isMobile ? 6 : 8}
            overflow='hidden'
            {...withBorder && {
                border: '1px solid',
                borderColor: 'grayscale.shade20',
            }}
            sx={{
                ...backgroundImage && {
                    backgroundImage,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: isTablet ? '60%' : 'contain',
                    backgroundPosition: 'right bottom',
                },
                ...sx,
            }}
            {...props}
        >
            {children}
        </Box>
    );
};
